

import apiClient from './apiMainClient'

/**
 * Obtém uma lista de UserRoles com parâmetros opcionais.
 *
 * @param {Object} params - Parâmetros de consulta para a requisição.
 * @param {number} [params.page] - Número da página para paginação.
 * @param {number} [params.limit] - Número de UserRoles por página.
 * @param {string} [params.sort] - Campo para ordenação.
 * @returns {Promise<Object[]>} - Lista de UserRoles.
 */
export const getSpecialtyConsultation = async (params = {}) => {
  try {
    const response = await apiClient.get('/specialty/consultation', { params })
    return response.data
  } catch (error) {
    console.error(error)
    throw error
  }
}

/**
 * Cria uma nova especialidade de atendimento.
 */
export const createSpecialtyConsultation = async (data) => {
  try {
    const response = await apiClient.post('/specialty/consultation', data)
    return response.data
  } catch (error) {
    console.error(error)
    throw error
  }
}

/**
 * Obtem uma especialidade de atendimento por ID.
 */
export const getSpecialtyConsultationById = async (id) => {
  try {
    const response = await apiClient.get(`/specialty/consultation/${id}`)
    return response.data
  } catch (error) {
    console.error(error)
    throw error
  }
}

/**
 * Atualiza uma especialidade de atendimento.
 */
export const updateSpecialtyConsultation = async (id, data) => {
  try {
    const response = await apiClient.put(`/specialty/consultation/${id}`, data)
    return response.data
  } catch (error) {
    console.error(error)
    throw error
  }
}

/**
 * Obtem todas as telemedicinas ativas para autocmplete.
 */
export const getSpecialtyConsultationAll = async () => {
  try {
    const response = await apiClient.get('/specialty/consultation/all')
    return response.data
  } catch (error) {
    console.error(error)
    throw error
  }
}

/**
 * Obtem todas as telemedicinas ativas para autocmplete.
 */
export const getSpecialtyDiagnosticAll = async () => {
  try {
    const response = await apiClient.get('/specialty/diagnostic/all')
    return response.data
  } catch (error) {
    console.error(error)
    throw error
  }
}
